/**
 * Конфигурация UI
 *
 * Начальные значений устанавилаются при подклчюении Core во Vue приложение через app.use(PluginCore, options)
 */
export default {

	/**
	 * Имя темы оформления
	 *
	 * В данный момент не используется для загрузки css
	 *
	 * @todo Реализовать загрузки и замену css темы на стороне UI
	 *
	 * @see https://ui.topvisor.com/?path=/docs/core-theme--docs
	 */
	themeName: 'light' as 'light' | 'dark' | string,

	/**
	 * CSS-классы модификаторы для документа страницы
	 *
	 * Могут испоьзвоаться компонентами для включения необхоимых режимов отображения страницы
	 *
	 * Разные компоненты могут добавлять один и тот же класс, чтобы не было конфликтов каждый компонент управляет только своим классом:
	 * - Ключ - уникальное имя компонента, например в setup: `const uid = Math.random();`
	 * - Значение - класс модификатора
	 */
	documentClassModificators: new Map<string | number, string>(),

	/**
	 * Базовая ширина страницы для отображения ПК / Мобильной версии сайта
	 *
	 * @see Core state isMobile
	 */
	widthForMobile: 900,

	/**
	 * Формат даты, который будет испоьзоваться по умолчанию для вывода даты, как правило, завсит от текущего пользователя
	 */
	dateFormat: 'Y-m-d',

	/**
	 * Валюта, которая будет испоьзоваться по умолчанию, как правило, завсит от текущего пользователя
	 */
	currency: 'USD' as 'RUB' | 'USD' | 'EUR',

	/**
	 * Для Москвы: +0300
	 */
	gmt: new Date().toString().match(/GMT(\S+)/)?.[1] as string,
};
